import styled from 'styled-components';

export const SelectStyles = styled.select`
  appearance: none;
  border: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;
  padding: 10px;
  font-family: var(--font-family);
  font-size: 18px;
  min-width: 150px;
  margin-bottom: calc(26px + 16px);
  border-radius: 8px;
  border: 1px solid lightgray;
  display: block;
`;
